import Vue from 'vue';
import coupletVue from './index.vue';
import merge from '@/utils/merge';

const defaults = {};

const CoupletConstructor = Vue.extend(coupletVue);
const Couplet = (options) => {
	options = merge({}, defaults, options);
	let instance = new CoupletConstructor({
		data: options
	});
	instance._vm = instance.$mount();
	instance._el = instance.$el;
	instance._instance = instance;
	document.body.appendChild(instance.$el); // 把生成的提示的dom插入body中
	return instance;
};

export default Couplet;
